import { Injectable, OnDestroy } from "@angular/core";
import { SettingsDataModel, SettingsRegistrationViewModel, SettingsDMKey, SettingsRegistrationDataViewModel, SettingsMainNavDataViewModel } from "../shared/models/settings.model";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { CoreLogService } from "./log.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ContentType } from "../shared/contentTypes";
import { IObjectObserver } from "./IObjectObserver";
import { ObjectObserverFactory } from "./objectObserverFactory";

@Injectable({
  providedIn: "root"
})
export class SettingsService implements OnDestroy {
  private _settingsObsServer: IObjectObserver<SettingsDataModel>;

  constructor(private _coreLogService: CoreLogService,
    objObsInjectHelper: CircularInjectionHelper) {
    this._settingsObsServer = ObjectObserverFactory.GetObjectObserverByInjectionHelper<SettingsDataModel>(ContentType.Settings, objObsInjectHelper);
  }

  public get ObserveChanges(): Observable<(string | number)[]> {
    return this._settingsObsServer.ObserveChanges;
  }

  /**
    * Getting the SettingsRegistrationViewModel
    * @result return a promise that resolves the SettingViewModel
    */
  public GetSettingRegistrationViewModel(): Promise<SettingsRegistrationViewModel> {
    const me = this;
    return new Promise<SettingsRegistrationViewModel>((resolve, reject) => {
      me._settingsObsServer.GetObject(SettingsDMKey)
        .then((settingsModel) => {
          me.mapToSettingRegistrationViewModel(settingsModel).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  }

  /**
  * Getting the SettingsRegistrationDataViewModel
  * @result return a promise of  SettingsRegistrationViewModel; used in ragistrationdata
  */
  public GetSettingRegistrationDataViewModel(): Promise<SettingsRegistrationDataViewModel> {
    const me = this;
    return new Promise<SettingsRegistrationDataViewModel>((resolve, reject) => {
      me._settingsObsServer.GetObject(SettingsDMKey)
        .then((settingsModel) => {
          me.mapToSettingRegistrationDataViewModel(settingsModel).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  }

  /**
  * Getting the SettingsMainNavDataViewModel
  * @result return a promise of SettingsMainNavDataViewModel; used in ragistrationdata
  */
  public GetSettingsMainNavDataViewModel(): Promise<SettingsMainNavDataViewModel> {
    const me = this;
    return new Promise<SettingsMainNavDataViewModel>((resolve, reject) => {
      me._settingsObsServer.GetObject(SettingsDMKey)
        .then((settingsModel) => {
          me.mapToSettingsMainNavDataViewModel(settingsModel).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  }

  // Mapper

  /**
  * map a SettingsDataModel to SettingsRegistrationViewModel
  * @param model Get a SettingsDataModel for mapping
  * @result return a SettingsRegistrationViewModel
  */
  private async mapToSettingRegistrationViewModel(model: SettingsDataModel): Promise<SettingsRegistrationViewModel> {
    const viewModel = new SettingsRegistrationViewModel();
    viewModel.id = model.id;
    viewModel.register_term_text_de = model.register_term_text_de.replace("<customername>", environment.CustomerName);
    viewModel.register_term_text_en = model.register_term_text_en.replace("<customername>", environment.CustomerName);;
    viewModel.newsletter_text_de = model.newsletter_text_de;
    viewModel.newsletter_text_en = model.newsletter_text_en;
    viewModel.newsletter_show_optin = model.newsletter_show_optin;
    viewModel.google_client_id = model.google_client_id;
    viewModel.facebook_app_id = model.facebook_app_id;
    viewModel.thirdparty_login_enabled = model.thirdparty_login_enabled;
    return Promise.resolve(viewModel);
  }

  /**
 * map a SettingsDataModel to SettingsRegistrationDataViewModel
 * @param model Get a SettingsDataModel for mapping
 * @result return a SettingsRegistrationDataViewModel
 */
  private async mapToSettingRegistrationDataViewModel(model: SettingsDataModel): Promise<SettingsRegistrationDataViewModel> {
    const viewModel = new SettingsRegistrationDataViewModel();
    viewModel.id = model.id;
    viewModel.register_welcome_text_de = model.register_welcome_text_de.replace("<customername>", environment.CustomerName);
    viewModel.register_welcome_text_en = model.register_welcome_text_en.replace("<customername>", environment.CustomerName);
    return Promise.resolve(viewModel);
  }

  /**
* map a SettingsDataModel to SettingsMainNavDataViewModel
* @param model Get a SettingsDataModel for mapping
* @result return a SettingsRegistrationDataViewModel
*/
  private async mapToSettingsMainNavDataViewModel(model: SettingsDataModel): Promise<SettingsMainNavDataViewModel> {
    const viewModel = new SettingsMainNavDataViewModel();
    viewModel.id = model.id;
    viewModel.language = model.language;
    return Promise.resolve(viewModel);
  }

  ngOnDestroy(): void {
  }

}
